import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { equipmentAlertCategorySearchSchema } from '@/routes/_staff/equipment/-shared/alerts/equipmentAlertCategorySearchSchema';
import { supportsItemAggregateView } from './-constants';
import { equipmentAlertFilterFields } from './-shared/equipmentAlertFilterFields';
import { AlertViewMode } from './-zod-schema.types';
export const EquipmentAlertsSearchSchema = z.object({
  ...dataGridSearchFields,
  viewMode: z.enum(['individual', 'item']).default(AlertViewMode.INDIVIDUAL),
  category: equipmentAlertCategorySearchSchema,
  freeText: z.string().optional(),
  equipmentTypeIdIn: equipmentAlertFilterFields.equipmentTypeIdIn,
  equipmentItemIdIn: equipmentAlertFilterFields.equipmentItemIdIn,
  placementPlaceIdIn: equipmentAlertFilterFields.placementPlaceIdIn
}).transform(search => {
  let result = search;
  if (!supportsItemAggregateView(search.category) && search.viewMode === AlertViewMode.ITEM) {
    result = {
      ...result,
      viewMode: AlertViewMode.INDIVIDUAL
    };
  }
  if (search.category !== 'REPLACEMENT_DUE' && search.placementPlaceIdIn != null) {
    result = {
      ...result,
      placementPlaceIdIn: undefined
    };
  }
  return result;
});
export type EquipmentAlertsSearch = z.infer<typeof EquipmentAlertsSearchSchema>;